import React, { Component } from 'react';
import { Grid, Cell, List, ListItem, ListItemContent } from 'react-mdl';


class Contact extends Component {
  render() {
    return(
      <div className="contact-body">
        <Grid className="contact-grid">
          <Cell col={6}>
            <h2>Donovan Buccat</h2>
            <img
              src="http://donovanbuccat.com/Donovan-Buccat.jpg"
              alt="avatar"
              style={{height: '250px'}}
               />
             <p style={{ width: '75%', margin: 'auto', paddingTop: '1em'}}>Software Engineer</p>
             <p style={{ width: '75%', margin: 'auto', paddingTop: '1em'}}>UC Santa Cruz Alumni</p>
             <p style={{ width: '75%', margin: 'auto', paddingTop: '1em'}}>Computer Science</p>

          </Cell>
          <Cell col={6}>
            <h2>Contact Me</h2>
            <hr/>

            <div className="contact-list">
              <List>
                <ListItem>
                  <ListItemContent style={{fontSize: '160%', fontFamily: 'Anton'}}>
                    <i className="fa fa-phone-square SocialHeading" aria-hidden="true"/>
                    (707) 673-7184
                  </ListItemContent>
                </ListItem>

                <ListItem>
                  <ListItemContent style={{fontSize: '135%', fontFamily: 'Anton'}}>
                    <i className="fa fa-envelope SocialHeading" aria-hidden="true"/>
                    donovanbuccat@gmail.com
                  </ListItemContent>
                </ListItem>

                <ListItem>
                  <ListItemContent style={{fontSize: '102%', fontFamily: 'Anton'}}>
                    <i className= "fa fa-linkedin-square SocialHeading" aria-hidden="true"/>
                    <a href="https://www.linkedin.com/in/donovan-buccat" rel="noopener noreferrer" target="_blank">https://www.linkedin.com/in/donovan-buccat</a>
                  </ListItemContent>
                </ListItem>


              </List>
            </div>
          </Cell>
        </Grid>
      </div>
    )
  }
}

export default Contact;
